import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobManagementPage from '@/features/jobs/job-management/JobManagementPage';

// EU-560 — "Gestão de vaga": destino do clique no nome da vaga (ou "Editar" no
// menu ⋮) na listagem, substituindo a entrada direta no hub de edição. O hub
// continua em `/vagas/$jobId/editar`, alcançado pelo painel "Dados".
export const jobManagementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId',
  component: JobManagementPage,
});
